<template>
    <div class="container">
        <h1 class="my-3">Help &amp; Advice</h1>
        <div class="row">
            <div class="col-12 col-md-3">
                <help-menu
                    :active-tab="activeTab"
                ></help-menu>
            </div>
            <div class="col-12 col-md-8 mb-3">
                <help-content
                    :active-tab="activeTab"
                ></help-content>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeTab: 'understanding-your-tyres'
            }
        },
        mounted() {
			//removes loading placeholder - fixes CLS issue
			document.querySelector('#loadingPlaceholder').style.display = 'none';

            this.emitter.on('changeActiveTab', data => {
                this.activeTab = data;
            });
        }
    }
</script>

<style lang="scss" scoped>

</style>